import { AgGridTable } from 'components/AgGrid/AgGridTable';
import { Combobox, Grid, GridItem, cnMixSpace, Text } from 'uikit';

import { useCallback } from 'react';

import { ConstructionObjectCombobox } from '../../../../UerProject/WorkOrder/ConstructionObjectCombobox';
import type { IObjectTabFilters, IObjectTabProps } from '../../helpersAndTypes';
import { CHAPTER_ITEMS } from '../../helpersAndTypes';

import { useObjectTableColumns, useObjectTableData } from './hooks';

import Styles from './ObjectTab.module.css';

export const ObjectTab = (props: IObjectTabProps) => {
    const {
        workOrderObjects,
        constructionTypeId,
        objectTabFilters,
        onChangeObjectTabFilters,
        checkedObjects,
        onChangeCheckedObjects,
        getObjItemDisabled,
        getObjItemLabel,
    } = props;

    const tableColumns = useObjectTableColumns({
        checkedObjects,
        onChangeCheckedObjects,
    });

    const tableRows = useObjectTableData({
        workOrderObjects,
        objectTabFilters,
        constructionTypeId,
    });

    const handleTabFilterChangeCreator = useCallback(
        (key: keyof IObjectTabFilters) =>
            ({ value }: { value: IObjectTabFilters[keyof IObjectTabFilters] }) => {
                onChangeObjectTabFilters({
                    [key]: value,
                });
            },
        [onChangeObjectTabFilters],
    );

    return (
        <>
            <Grid
                cols={6}
                gap="xl"
                rowGap="xl"
                colGap="xl"
                className={cnMixSpace({
                    pB: 'm',
                })}
            >
                <GridItem col={3}>
                    <Combobox
                        placeholder="Раздел"
                        items={CHAPTER_ITEMS}
                        value={objectTabFilters.chapter}
                        onChange={handleTabFilterChangeCreator('chapter')}
                        size="s"
                    />
                </GridItem>
                <GridItem col={3}>
                    <ConstructionObjectCombobox
                        constructionTypeId={constructionTypeId}
                        objectId={objectTabFilters.object?.id}
                        onChange={handleTabFilterChangeCreator('object')}
                        workOrderObjects={workOrderObjects}
                        getItemDisabled={getObjItemDisabled}
                        getItemLabel={getObjItemLabel}
                    />
                </GridItem>
            </Grid>
            {!objectTabFilters?.object && (
                <div className={Styles.emptyTextBlock}>
                    <Text size="s" view="secondary">
                        Для отображения данных выберите объект строительства
                    </Text>
                </div>
            )}
            {objectTabFilters?.object && (
                <AgGridTable
                    className={Styles.table}
                    columnDefs={tableColumns}
                    rowData={tableRows}
                    rowClassRules={{
                        root: (p) => p?.data?.level === 0,
                        common: (p) => p?.data?.level !== 0,
                    }}
                />
            )}
        </>
    );
};

ObjectTab.displayName = 'ObjectTab';
